<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('updatePassword.title')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="账号：">
            <span>{{ $store.state.user.username }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="姓名：">
            <span>{{ $store.state.user.realName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话：">
            <span>{{ $store.state.user.mobile }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="password" label="原密码：">
        <el-input
          v-model="dataForm.password"
          type="password"
          :placeholder="$t('updatePassword.password')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="新密码：">
        <el-input
          v-model="dataForm.newPassword"
          type="password"
          :placeholder="$t('updatePassword.newPassword')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="comfirmPassword" label="确认密码：">
        <el-input
          v-model="dataForm.comfirmPassword"
          type="password"
          :placeholder="$t('updatePassword.comfirmPassword')"
        ></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t('confirm')
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { clearLoginInfo } from '@/utils'
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        password: '',
        newPassword: '',
        comfirmPassword: '',
      },
    }
  },
  computed: {
    dataRule() {
      var validateComfirmPassword = (rule, value, callback) => {
        if (this.dataForm.newPassword !== value) {
          return callback(
            new Error(this.$t('updatePassword.validate.comfirmPassword'))
          )
        }
        callback()
      }
      return {
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
        ],
        comfirmPassword: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
          { validator: validateComfirmPassword, trigger: 'blur' },
        ],
      }
    },
  },
  methods: {
    init() {
      this.visible = true
      this.$nextTick(() => {
        if(this.$refs['dataForm']){
this.$refs['dataForm'].resetFields()
        }
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          this.$http
            .put('/sys/user/password', this.dataForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.visible = false
                  clearLoginInfo()
                  this.$router.replace({ name: 'login' })
                },
              })
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
}
</script>
